export const MOTIVE_SELECT_INACTIVE_OPTION = 'inactive';
export const MOTIVE_SELECT_PERSONAL_OPTION = 'personal';
export const MOTIVE_SELECT_OTHER_ACCOUNTS_OPTION = 'otherAccounts';
export const MOTIVE_SELECT_ERRORS_OPTION = 'errors';
export const MOTIVE_SELECT_BETTER_OFFERS_OPTION = 'betterOffers';
export const MOTIVE_SELECT_OTHER_OPTION = 'other';

export const MOTIVE_SELECT_OPTIONS = [
    {
        value: MOTIVE_SELECT_INACTIVE_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_1'
    },
    {
        value: MOTIVE_SELECT_PERSONAL_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_2'
    },
    {
        value: MOTIVE_SELECT_OTHER_ACCOUNTS_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_3'
    },
    {
        value: MOTIVE_SELECT_ERRORS_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_4'
    },
    {
        value: MOTIVE_SELECT_BETTER_OFFERS_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_5'
    },
    {
        value: MOTIVE_SELECT_OTHER_OPTION,
        label: 'cancellation_account-cancellation_account_reason_dropdown_6'
    }
]

export const MOTIVE_SELECT_OPTIONS_MAPPING = {
    [MOTIVE_SELECT_INACTIVE_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_1',
    [MOTIVE_SELECT_PERSONAL_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_2',
    [MOTIVE_SELECT_OTHER_ACCOUNTS_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_3',
    [MOTIVE_SELECT_ERRORS_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_4',
    [MOTIVE_SELECT_BETTER_OFFERS_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_5',
    [MOTIVE_SELECT_OTHER_OPTION]: 'cancellation_account-cancellation_account_reason_dropdown_6'
}

export const STATUSES = {
    FETCHING: 'FETCHING',
    FETCHED: 'FETCHED',
    SAVING: 'SAVING',
    SAVED: 'SAVED',
    ERROR: 'ERROR',
    IDLE: 'IDLE',
}

export const VISIBLE_STEPS = [
    { step: 1, order: 1 },
    { step: 2, order: 1 },
    { step: 3, order: 1 },
];

export const CARD_DETAILS_TEMPLATE = [
    {
        id: 'alias',
        label: 'profile-profileAliasLabel',
        type: 'single',
        format_type: '',
        order: 1,
        visible: VISIBLE_STEPS,
    },
    {
        id: 'iban',
        label: 'accountDetails-iban',
        type: 'single',
        format_type: '',
        order: 2,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 2 })),
    },
    {
        id: 'type',
        label: 'accountDetails-accountType',
        type: 'single',
        format_type: '',
        order: 3,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 3 })),
    },
    {
        id: 'intervenersList',
        label: 'contractsView-interveners',
        type: 'interveners',
        format_type: '',
        order: 4,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 4 })),
    },
    {
        type: 'separator',
        order: 5,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 5 })),
    },
    {
        id: 'motive',
        label: 'cancelChore-choreConfirmationComment',
        type: 'single',
        format_type: '',
        order: 6,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 6 })),
    },
    {
        type: 'separator',
        order: 7,
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 7 })),
    },
    {
        id: 'applicationDate',
        label: 'contractsView-applicationDate',
        type: 'single',
        order: 8,
        format_type: '',
        visible: VISIBLE_STEPS.map(step => ({ ...step, order: 8 })),
    },
];

export const LOCAL_STATE = {
    card_details_title: "contractsView-cardDetailsTitle",
    checkUserIsCollective: false,
}